import React from 'react';
import PropTypes from 'prop-types';
import events from '../../lib/events.js';

import custPrefsApi from '../../api/custPrefs';
import EmailPreferences from '../../models/emailPreferences';
import NotificationBar from './notificationBar';

import ExitPrompt from './exitPrompt.jsx';
import {countries, finishTypesFormat, locationTypesFormat, emailLanguages, systemTypeNamesFormat} from '../helpers/constants';
import {getURLParam, getLanguageFromLocale} from '../helpers/data-helper';
import EditableCheckbox from '../forms/editableCheckbox';
import {FormattedMessage, injectIntl, FormattedHTMLMessage} from 'react-intl';
import Loader from '../components/loader';


class Layout extends React.Component {
  static propTypes = {
    intl: PropTypes.any,
  };

  state = {
    email: '',
    bgGradient: false,
    preferences: null,
    hasSaved: false,
    customers: null,
    dealer: null,
    showPrompt: false,
    loaded: false,
  };

  componentWillMount() {
    const {formatMessage} = this.props.intl;

    const token = getURLParam('token');
    let unsubscribe = getURLParam('unsubscribe');
    let caslApproved = getURLParam('casl');
    let isVerify = getURLParam('isVerify');

    unsubscribe = unsubscribe && unsubscribe === 'true';
    caslApproved = caslApproved && caslApproved === 'true';
    isVerify = isVerify && isVerify === 'true';

    custPrefsApi.validateEmailToken(token).then(email => {
      this.setState({email: email});
      
      const apis = [];
      apis.push(custPrefsApi.getPreferences(this.state.email, caslApproved));
      apis.push(custPrefsApi.getAccountInfo(this.state.email));
      
      const serverSideVerified = window.isVerified;

      Promise.all(apis)
        .then((results) => {
          const prefs = results[0];
          const account = results[1];
          
          this.setState({
            preferences: EmailPreferences.fromApiFormat(prefs).clone(),
            account: account,
            dealer: account.dealer,
            customers: account.customers,
            loaded: true,
          });

          if(unsubscribe) {
            this.unsubscribeAll();
          }

          if(serverSideVerified && isVerify) {
            events.publish('success.user', {
              message: formatMessage({id: 'manifold.emailPrefs.verification.success'}),
            });
          }
          events.publish('set.language', this.state.preferences.emailLanguagePreference);

        }).catch(err => {
          console.log(err);
        });


      // If user closes window; open a prompt to save
      window.addEventListener('beforeunload', e => {
        if (this.state.hasSaved) {
          return undefined;
        }
        var confirmationMessage = formatMessage({id: 'manifold.emailprefs.save.confirmation'}, {email});

        // this.setState({showPrompt: true});
        (e || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage;
      });
    });
  }

  setEmailsLanguage = lang => {
    let preferences = this.state.preferences;

    preferences.emailLanguagePreference = lang;
    this.setState({preferences: preferences});
  };

  onCancel = () => {
    // Pop dialog warning user to save changes or not
    this.setState({showPrompt: false});
    window.close();
  };

  getContactsTable = contacts => {
    const {formatMessage} = this.props.intl;
    const rows = [];

    contacts.forEach((cu, i) => {
      rows.push(<tr key={i}>
        <td>{!!cu.NameFirst ? cu.NameFirst + ' ' + cu.NameLast : !!cu.Organization ? cu.Organization : '-'}</td>
        <td>{cu.Email}</td>
        <td>{cu.HomePhone}</td>
        <td>{cu.MobilePhone || cu.WorkPhone ? cu.MobilePhone || cu.WorkPhone : formatMessage({id: 'general.none'})}</td>
      </tr>
      );
    });
    return <table className='contact-table'>
      <tr>
        <th>{formatMessage({id: 'manifold.contact.name'})}</th>
        <th>{formatMessage({id: 'manifold.contact.email'})}</th>
        <th>{formatMessage({id: 'manifold.contact.home.phone'})}</th>
        <th>{formatMessage({id: 'manifold.contact.home.phone'})}</th>
      </tr>
      {rows}
    </table>;
  };

  getCustomerRows = () => {
    const {formatMessage} = this.props.intl;
    const {dealer} = this.state;
    const customers = [];
    const systemTypeNames = systemTypeNamesFormat(formatMessage);
    const finishTypes = finishTypesFormat(formatMessage);
    const locationTypes = locationTypesFormat(formatMessage);
    const volumeUOM = dealer && dealer.Country === countries.CA ? formatMessage({id: 'manifold.pool.volume.litres'}) :
      formatMessage({id: 'manifold.pool.volume.gallons'});

    this.state.customers.map((c, i) => {
      customers.push(
        <row key={i} className='customer-section'>
          <h2><FormattedMessage id='manifold.account.information.title'/></h2>
          <p> {c.Address1 ? c.Address1 : ''}</p>
          <p> {c.Address2 ? c.Address2 : ''}</p>
          <p> {c.City ? c.City + ', ' : ''} {c.State ? c.State : ''}</p>
          <p> {c.Country ? c.Country + ', ' : ''} {c.Zip ? c.Zip : ''}</p>
          <h3><FormattedMessage id='manifold.contacts.title'/></h3>
          <div className='contact-block'>
            {this.getContactsTable(c.CustomerContacts)}
          </div>
          {c.Pools.length > 0 ?
            <div className='pool-block'>
              <h3><FormattedMessage id='manifold.pool.information.title'/></h3>
              <div>
                {c.Pools.map((p, i) => {
                  return <p key={i} className='pool-section'>
                    <h4><strong>{systemTypeNames[p.TypeID]}</strong></h4>
                    <div>{formatMessage({id: 'manifold.pool.volume'}, {volume: p.Volume})} {volumeUOM}</div>
                    <div>{formatMessage({id: 'manifold.pool.finish'}, {finish: finishTypes[p.Finish]})}</div>
                    <div>{formatMessage({id: 'manifold.pool.location'}, {location: locationTypes[p.Location]})}</div>
                  </p>;
                })}
              </div>
            </div> : <h3><FormattedMessage id='manifold.no.pools.found'/></h3>
          }
        </row>
      );
    });


    return customers;
  };

  _eventHashchange = null;
  _eventSiteErrorOff = null;
  _eventSiteErrorOn = null;
  _userChange = null;

  dataChanged = e => {
    let prefs = this.state.preferences;

    prefs[e.key] = e.value;
    this.setState({preferences: prefs});
    // If anything changes at all; set so user has to save again
    this.setState({hasSaved: false});
  };

  saveChanges = () => {
    const {formatMessage} = this.props.intl;
    // Based on checkboxes make our email preferences for customer
    let preferences = this.state.preferences;

    this.setState({preferences: preferences});
    // this.setState({showPrompt: true});

    custPrefsApi.saveCustomerEmailPreferences(preferences)
      .then(() => {
        // Change page or close page
        this.setState({hasSaved: true});
        events.publish('success.user', {
          message: formatMessage({id: 'manifold.emailprefs.save.success'}),
        });
      });
  };

  unsubscribeAll = () => {
    let preferences = this.state.preferences;

    preferences.accountUpdate = false;
    preferences.latestFromBioguard = false;
    preferences.newsFromExpert = false;

    if (this.state.dealer && this.state.dealer.Country === countries.CA){
      preferences.CASL = false;
    }

    this.setState({preferences: preferences});
  };

  render() {
    const {formatMessage, locale} = this.props.intl;
    const {dealer} = this.state;
    let prefs = this.state.preferences;
    let optionsLanguages = [];

    emailLanguages.forEach(el => {

      optionsLanguages.push(<EditableCheckbox dataKey={el.val} value={prefs && prefs.emailLanguagePreference === el.val}
        onChange={() => this.setEmailsLanguage(el.val)} editMode={true} label={formatMessage({id: el.lang})} />);
    }, this);

    // Currently the exitprompt doesn't work with onUnload functionality; using native one instead

    return <Loader loaded={this.state.loaded}>
      <div>
        <ExitPrompt showState={this.state.showPrompt} preferences={this.state.preferences} hideModal={this.onCancel}/>
        <table style={{margin: 'auto'}}>
          <tr>
            <td valign='top'>
              <container>
                <row>
                  <center className='logo-container'>
                    <img className='logo' src='Content/img/logo.png' alt='BioGuard Logo' />
                  </center>
                </row>
                <NotificationBar debugMode={true}/>
                <div className='body-container'>
                  {this.state.dealer ?
                    <section className='dealer-section'>
                      <h1><FormattedMessage id='manifold.dealer.information.title'/></h1>
                      <div className='dealer-name'>
                        <h4><strong>{this.state.dealer.Name ? this.state.dealer.Name : ''}</strong></h4>
                        {this.state.dealer.LogoLink ?
                          <img src={this.state.dealer.LogoLink} className='dealer-logo' alt='BioGuard Logo' /> :
                          ''
                        }
                      </div>
                      <p>{this.state.dealer.Address1 ? this.state.dealer.Address1 : ''}</p>
                      <p>{this.state.dealer.Address2 ? this.state.dealer.Address2 : ''}</p>
                      <p>{this.state.dealer.City ? this.state.dealer.City + ', ' : ''} {this.state.dealer.State ? this.state.dealer.State : ''}</p>
                      <p>{this.state.dealer.Country ? this.state.dealer.Country + ', ' : ''} {this.state.dealer.Zip ? this.state.dealer.Zip : ''}</p>
                    </section> : ''}
                  {this.state.customers ?
                    <section className='customer-block'>
                      {this.getCustomerRows()}
                    </section> : ''
                  }
                </div>
                <row>
                  {(() => {
                    if (prefs !== null) {
                      return <div className='body-container'>
                        <h2><FormattedMessage id='manifold.emailprefs.title'/></h2>
                        <p><FormattedHTMLMessage id='manifold.account.email' values={{email: this.state.email}}/></p>
                        <p className='sub-heading'><FormattedMessage id='manifold.emailprefs.language.title'/>:</p>
                        <div className='languages-wrapper'>
                          {optionsLanguages}
                        </div>
                        <p className='sub-heading'><FormattedMessage id='manifold.emailprefs.instructions'/></p>
                        <EditableCheckbox dataKey='accountUpdate' value={prefs.accountUpdate}
                                          onChange={this.dataChanged} editMode={true}
                                          label={formatMessage({id: 'manifold.emailprefs.alexpro.title'})}/>
                        <p><FormattedMessage id='manifold.emailprefs.alexpro.description'/></p>
                        <EditableCheckbox dataKey='latestFromBioguard' value={prefs.latestFromBioguard}
                                          onChange={this.dataChanged} editMode={true}
                                          label={formatMessage({id: 'manifold.emailprefs.latestbioguard.title'})}/>
                        <p><FormattedMessage id='manifold.emailprefs.latestbioguard.description'/></p>
                        <EditableCheckbox dataKey='newsFromExpert' value={prefs.newsFromExpert}
                                          onChange={this.dataChanged} editMode={true}
                                          label={formatMessage({id: 'manifold.emailprefs.newsexpert.title'})}/>
                        <p><FormattedMessage id='manifold.emailprefs.newsexpert.description'/></p>

                        <div style={{padding: '20px 0', border: '1px solid #d2d3d3'}}>
                          <EditableCheckbox dataKey='unsubscribeAll'
                                            value={!prefs.newsFromExpert && !prefs.accountUpdate && !prefs.latestFromBioguard}
                                            onChange={this.unsubscribeAll} editMode={true}
                                            label={formatMessage({id: 'manifold.emailprefs.stop.all'})}/>
                        </div>
                        <row>
                          <button className='btn-secondary' onClick={() => this.onCancel()}><FormattedMessage
                            id='manifold.cancel'/></button>
                          <button className='btn-primary' onClick={() => this.saveChanges()}><FormattedMessage
                            id='manifold.update'/></button>
                        </row>
                      </div>;
                    }
                    return '';
                  })()}
                </row>
                <row>
                  <center>
                    <div className='footer-container text-center'>
                      <img className='logo' src='Content/img/logos/bioguard.png' alt='BioGuard Logo' />
                      <p className='text-center'>
                        &copy; <FormattedMessage id='manifold.footer.copyright'/>
                      </p>
                      <p className='text-center'>
                        <a href='#'><FormattedMessage id='manifold.footer.terms.conditions'/></a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a href='http://www.bioguard.com/'><FormattedMessage id='manifold.footer.visit.website'/></a>
                      </p>
                      {dealer && dealer.Country === countries.CA ? 
                        <p className='text-center'>
                          <FormattedMessage id='manifold.footer.biolabCA.postalCode'/><br/>
                          <FormattedMessage id='manifold.footer.biolabCA.address'/><br/>
                          <FormattedMessage id='manifold.footer.biolabCA.phone'/><br/>
                        </p>:
                        <p className='text-center'>
                          <FormattedMessage id='manifold.footer.biolabUS.postalCode'/><br/>
                          <FormattedMessage id='manifold.footer.biolabUS.address'/><br/>
                          <FormattedMessage id='manifold.footer.biolabUS.phone'/><br/>
                        </p>}
                    </div>
                  </center>
                </row>
              </container>
            </td>
          </tr>
        </table>
      </div>
    </Loader>;
  }
}

export default injectIntl(Layout);
